import React, { useContext, useEffect, useState } from 'react';
import { Link, Spinner, useToast } from '@chakra-ui/react';
import { ConfigContext } from './utils/Config';
import { useTranslation } from 'react-i18next';

const UserBlock = ({ language }) => {
  const { t } = useTranslation();
  const [isDropdownExpanded, setIsDropdownExpanded] = useState(false);
  const config = useContext(ConfigContext);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownExpanded(!isDropdownExpanded);
  };

  const toast = useToast();

  useEffect(() => {
    const handleUserLoggedOut = () => {
      setIsAuthenticated(false);
    };

    const handleUserLoggedIn = () => {
      setIsAuthenticated(true);
    };

    const handleUserAuthenticated = () => {
      setIsAuthenticated(true);
    };

    if (config.accessToken) {
      setIsAuthenticated(true);
    }

    window.addEventListener('userLoggedOut', handleUserLoggedOut);
    window.addEventListener('userLoggedIn', handleUserLoggedIn);
    window.addEventListener('userAuthenticated', handleUserAuthenticated);

    return () => {
      window.removeEventListener('userLoggedOut', handleUserLoggedOut);
      window.removeEventListener('userLoggedIn', handleUserLoggedIn);
      window.removeEventListener('userAuthenticated', handleUserAuthenticated);
    };
  }, [config.accessToken]);

  useEffect(() => {
    const handleUserLoggedOut = () => {
      setIsAuthenticated(false);
    };

    const handleUserLoggedIn = () => {
      setIsAuthenticated(true);
    };

    if (config.accessToken) {
      setIsAuthenticated(true);
    }

    window.addEventListener('userLoggedOut', handleUserLoggedOut);
    window.addEventListener('userLoggedIn', handleUserLoggedIn);

    return () => {
      window.removeEventListener('userLoggedOut', handleUserLoggedOut);
      window.removeEventListener('userLoggedIn', handleUserLoggedIn);
    };
  }, [config.accessToken]);

  const handleLogout = () => {
    setIsLoggingOut(true);
    config.setAccessToken(null);
    setIsDropdownExpanded(false);
    window.dispatchEvent(new Event('userLoggedOut'));
    toast({
      title: t('userBlock.logoutSuccessful'),
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
    setIsLoggingOut(false);
  };

  if (!isAuthenticated) {
    return (
      <div className="user-block">
        <div className="logged-out">
          <Link href={`/login?redirect=${window.location.href}`}>
            {t('userBlock.login')}
          </Link>
          {' '}
          {t('userBlock.or')}
          {' '}
          <Link href={`/register?redirect=${window.location.href}`}>
            {t('userBlock.register')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="user-block">
      <div className="logged-in">
        <div className={`dropdown ${isDropdownExpanded ? 'open' : ''}`}>
          <button
            className="btn btn-secondary"
            id="dropdownMenuButton"
            type="button"
            onClick={toggleDropdown}
          >
            <i className="fa fa-user-o" aria-hidden="true" style={{ marginRight: '6px' }}></i>
            {config.userData?.first_name
              ? config.userData.first_name
              : config.userData?.mail || t('userBlock.user')}
            <i
              className={`fa ${isDropdownExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}
              aria-hidden="true"
            ></i>
          </button>
          <div className="dropdown-menu">
            <Link className="dropdown-item" href={`/my-account`}>
              {t('userBlock.myAccount')}
            </Link>
            <Link className="dropdown-item" href={`/my-bids`}>
              {t('userBlock.myBidsAndCredit')}
            </Link>
            <Link className="dropdown-item" href={`/my-favorites`}>
              {t('userBlock.myFavorites')}
            </Link>
            <Link className="dropdown-item" href={`/my-interests`}>
              {t('userBlock.myInterests')}
            </Link>
            <button
              className="dropdown-item last"
              onClick={handleLogout}
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              {isLoggingOut ? (
                <Spinner size="sm" color="gray.500" mr={2}/>
              ) : null}
              {t('userBlock.logout')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBlock;